import axios from 'axios';
import { getApiEndpoint } from '../appconfig';
import {
  getScreenName,
  getUserIsLoggedIn,
  getUserToken,
} from '../Utils/helper';
import { fireEvent } from '../Utils/fireEvent';

const BASE_API_URL = getApiEndpoint();

export const createRestApiClient = (
  forceDeleteAuth = false,
  loginRequired = false,
  isForProd = false,
) => {
  const headers = {
    'authorization': getUserToken(),
    'Mylo-In-App': false,
    'platform': 'web',
  };

  const restApiClient = axios.create({
    baseURL: isForProd ? 'https://api.myloapp.in/' : BASE_API_URL,
    headers: headers,
  });
  restApiClient.interceptors.request.use(function (config) {
    // if the api call is on client side and user is logged out then remove authentication

    if (
      ((typeof window !== 'undefined' && !getUserIsLoggedIn()) ||
        forceDeleteAuth) &&
      !loginRequired
    ) {
      delete config.headers['authorization'];
    }
    return config;
  });

  restApiClient.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx causes this function to trigger
      // Do something with response data
      return response;
    },
    function (error) {
      if (!global) {
        fireEvent({
          category: 'api_error',
          screen_name: getScreenName(),
          error: error.message,
          req: error.config.url,
        });
      }
      return Promise.reject(error);
    },
  );
  return restApiClient;
};
